import { render, staticRenderFns } from "./NotaireEditModal.vue?vue&type=template&id=79d4ab2a&"
import script from "./NotaireEditModal.vue?vue&type=script&lang=js&"
export * from "./NotaireEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports